import React from "react";
import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* Blank circle */}
      <circle 
        cx="14" 
        cy="14" 
        r="14" 
        fill="white" 
      />
      
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M14.0001 0.666626C6.64008 0.666626 0.666748 6.63996 0.666748 14C0.666748 21.36 6.64008 27.3333 14.0001 27.3333C21.3601 27.3333 27.3334 21.36 27.3334 14C27.3334 6.63996 21.3601 0.666626 14.0001 0.666626ZM14.0001 24.6666C8.12008 24.6666 3.33341 19.88 3.33341 14C3.33341 19.891 8.10904 24.6666 14.0001 24.6666ZM14.0001 24.6666C19.8801 24.6666 24.6667 19.88 24.6667 14C24.6667 19.891 19.8911 24.6666 14.0001 24.6666ZM24.6667 14C24.6667 8.10892 19.8911 3.33329 14.0001 3.33329C19.8801 3.33329 24.6667 8.11996 24.6667 14ZM3.33341 14C3.33341 8.10892 8.10904 3.33329 14.0001 3.33329C8.12008 3.33329 3.33341 8.11996 3.33341 14ZM20.1201 8.10663L11.3334 16.8933L7.88008 13.4533L6.00008 15.3333L11.3334 20.6666L22.0001 9.99996L20.1201 8.10663Z" 
        fill="#B6C4C8" 
      />
    </svg>
  );
}

export default SvgComponent;
